module.exports = "img/video-unmute.952e3b6.svg";